export const Colors = {
  GreyishBlue: '#c9ccd4',
  White: '#FFF',
  Black: '#000',
  WhiteGrey: '#F2F4F7',
  DarkGrey: '#333333',
  StrongYellow: '#90B400',
  LightTeal: '#00b0ca',
  BlueGray1: '#d8dbe0',
  BlueGray4: '#8A8D9C',
  Grey50: '#EBEDEF',
  Red: '#FF0000',
  Red50: '#E60000',
  Red60: '#C50011',
  Grey25: '#F5F6F7',
  Grey100: '#D8DBE0',
  Grey200: '#C9CCD4',
  Grey300: '#A8ACB8',
  Grey400: '#8A8D9C',
  Grey600: '#525365',
} as const;
